interface Benefit {
  icon: string;
  title: string;
  description: string;
}

const benefits: Benefit[] = [
  {
    icon: 'ri-drop-line',
    title: '100% Water Soluble',
    description:
      'Instantly dissolves for flawless RTD applications. Zero clouding, zero residue. Achieve full homogenization in cold and ambient-temperature liquids without surfactants.',
  },
  {
    icon: 'ri-eye-off-line',
    title: 'Tasteless',
    description:
      'Invisible in your formula. No masking agents required. Cordymax™ delivers a flavor-neutral profile with no earthy or bitter aftertaste that challenges palatability.',
  },
  {
    icon: 'ri-bar-chart-box-line',
    title: 'Standardized Purity',
    description:
      'Backed by full-panel COAs on every production lot. HPLC-verified cordycepin content, heavy metal testing, and microbial screening — batch to batch consistency guaranteed.',
  },
  {
    icon: 'ri-flask-line',
    title: 'Versatile Application',
    description:
      'For powders, capsules, and beverages. The fine particle size and stability profile make Cordymax™ compatible with encapsulation, sachets, RTD shots, and tablet compression.',
  },
];

export default function FormulatorBenefits() {
  return (
    <section id="benefits" className="bg-[#F8F9FA] py-12 px-6 border-t border-[#E2E8F0]">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-3 mb-8">
          <div>
            <p
              className="text-xs font-semibold tracking-widest uppercase text-[#2563EB] mb-1"
              style={{ fontFamily: 'Inter, sans-serif' }}
            >
              Ingredient Engineering
            </p>
            <h2
              className="text-[#0F172A] text-3xl xl:text-4xl leading-tight"
              style={{ fontFamily: 'Inter, sans-serif', fontWeight: 800, letterSpacing: '-0.05em' }}
            >
              Built for Formulators
            </h2>
          </div>
          <p className="text-sm text-[#475569] max-w-xs" style={{ fontFamily: 'Inter, sans-serif' }}>
            Every attribute of Cordymax™ is engineered for seamless B2B integration.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {benefits.map((item) => (
            <div key={item.title} className="flex flex-col gap-3">
              <div className="w-8 h-8 flex items-center justify-center rounded-md bg-[#0F172A]">
                <i className={`${item.icon} text-white text-sm`}></i>
              </div>
              <h3
                className="text-[#0F172A] text-base"
                style={{ fontFamily: 'Inter, sans-serif', fontWeight: 700, letterSpacing: '-0.02em' }}
              >
                {item.title}
              </h3>
              <p className="text-sm text-[#475569] leading-relaxed" style={{ fontFamily: 'Inter, sans-serif' }}>
                {item.description}
              </p>
            </div>
          ))}
        </div>

        {/* Compliance Row */}
        <div className="mt-10 pt-6 border-t border-[#E2E8F0] grid grid-cols-2 sm:grid-cols-4 gap-4">
          {[
            { label: 'GMP Certified', icon: 'ri-verified-badge-line' },
            { label: 'HPLC Verified', icon: 'ri-test-tube-line' },
            { label: 'Heavy Metals Tested', icon: 'ri-shield-check-line' },
            { label: 'Potency Tested', icon: 'ri-leaf-line' },
          ].map((badge) => (
            <div key={badge.label} className="flex items-center gap-2">
              <div className="w-6 h-6 flex items-center justify-center shrink-0">
                <i className={`${badge.icon} text-[#2563EB] text-base`}></i>
              </div>
              <span
                className="text-xs text-[#475569]"
                style={{ fontFamily: 'Inter, sans-serif', fontWeight: 600 }}
              >
                {badge.label}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
